import styled from 'styled-components';
import { IProduct } from '../../../../../interfaces/Product.interfaces';

interface ProductContentImageSectionProps {
  product: IProduct;
}

export const ProductContentImageSection = ({ product }: ProductContentImageSectionProps) => {
  return (
    <ImageWrapper>
      <img key={product.id} src={product.contentImageUrl} alt={product.id} />
    </ImageWrapper>
  );
};

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
